import React, { forwardRef } from 'react'
import Flags from 'country-flag-icons/react/3x2'
import ClickAwayComponent from 'components/ClickAwayComponent'
import Btn from 'components/Btn'
import CountrySelection from './CountrySelection'
import Logout from './Logout'
import { UilAngleDown, UilSignout } from '@iconscout/react-unicons'
import { MenuItem } from '@mui/material'


export default function UserInfo({user}) {
  

  return (
    <div className="absolute w-80 bg-white right-0 top-[60px] rounded-xl shadow-xl z-30">
      <span className="drop-reference"></span>
      <ul className="p-2">
        <li className="grid grid-cols-6 w-full p-1.5 cursor-pointer border-b">
          <label className="inline-flex rounded-full bg-failure w-10 h-10 col-span-1">
            <span className="text-md md:text-lg font-bold text-white m-auto">
              {`${user?.first_name[0]}${user?.last_name[0]}`} 
            </span>
          </label>

          <p className="font-medium text-dark-blue col-span-5">
            <span className="block">{`${user?.first_name} ${user?.last_name}`}</span>
            <span className="font-normal text-placeholder">{user?.email}</span>
          </p>
        </li>
        
        <ClickAwayComponent 
          Component={forwardRef(({ handleClick, open }, ref) => <>
            <li className="flex w-full p-1.5 px-7 items-center cursor-pointer border-b lg:hidden" ref={ref}>
              <Btn 
                className="w-full flex justify-start h-10"
                content={ () => 
                  <div className="w-full flex justify-start items-center">
                    <Flags.NG title="Nigeria" className="w-8 h-8 pr-2" />
                    <label className="">Nigeria</label>
                    <UilAngleDown className="ml-1" />
                  </div>
                }
                click={ handleClick }
              />
            </li>

            {
              open && <CountrySelection handleClick={handleClick} />
            }
          </>
          )}
        />
        
        <ClickAwayComponent 
          Component={forwardRef(({ handleClick, open }, ref) => <>
            {/* <li className="flex w-full p-1.5 px-7 items-center cursor-pointer" ref={ref}>
              <Btn 
                className="w-full flex justify-start h-10"
                content={ () => 
                  <div className="w-full flex justify-start items-center">
                    <UilSignout className="mr-2" />
                    <label className="">Logout</label>
                  </div>
                }
               
              />
            </li> */}
            <MenuItem onClick={ handleClick }>
              <UilSignout className="mr-2" /> Logout
            </MenuItem>

            {
              open && <Logout handleClick={handleClick} />
            }
          </>
          )}
        />
      </ul>
    </div>
  )
}
